import { SAVINGS_POT_CALCULATOR_FORM_SET_VALUE } from "../../../actions/savingsPotCalculator/savingsPotCalculatorForm";
import { savingsPotCalculatorFormValidation } from "./SavingsPotCalculatorForm";

export const savingsPotCalculatorValidation = (store, next, action) => {
  if (action.type.startsWith(SAVINGS_POT_CALCULATOR_FORM_SET_VALUE))
    return savingsPotCalculatorFormValidation(store, next, action);

  return null;
};
